import EventBus from '@/libs/event-bus/event-bus.js';

export class WebSocketClient {
    constructor(address) {
        this.address = address
        this.ws = null
        this.reconnecting = false
        this.forceClose = false
        this.status = {
            connected: false,
            message: ''
        }
        var self = this
        EventBus.$on('WS_SEND_MESSAGE', function(messageData) {
            self.ws.send(messageData)
        })
    }

    connect() {
        var self = this
        self.ws = new WebSocket(this.address);

        // Connection opened
        self.ws.onopen = function (event) {
            self.status.connected = true
            self.status.message = ''
            EventBus.$emit('WS_STATUS', self.status)

            console.info("WebSocket open:", event);
            var data = {
                ipAddress: '192.168.1.1',
                properties: [{
                    resolution: '1920X1080'
                }]
            }
            self.ws.send(JSON.stringify(data))
        }

        // Listen for messages
        self.ws.onmessage = function (event) {
            console.info('Message from server ', event.data);
            EventBus.$emit('WS_MESSAGE_RECEIVED', event.data)
        }

        // Listen for errors
        self.ws.onerror = function (event) {
            self.status.connected = false
            self.status.message = event.toString()
            EventBus.$emit('WS_STATUS', self.status)
            console.error("WebSocket error observed:", event);
        }

        // Listen for disconnect
        self.ws.onclose = function (event) {
            self.status.connected = false
            self.status.message = event.toString()
            EventBus.$emit('WS_STATUS', self.status)
            console.error("WebSocket closed!", event);
        }
    }
    disconnect() {
        this.forceClose = true
        this.ws.close()
        // EventBus.$on('WS_SEND_MESSAGE', this.send)
    }
    send(message) {
        var self = this
        // console.log("SEND", message)
        self.ws.send(message)
    }
    getStatus() {
        return this.ws.readyState
    }
    reconnect(address = null) {
        var self = this

        if (address != null) {
            self.address = address;
        }
        self.ws.close();
        self.ws.onopen = null;
        self.ws.onclose = null;
        self.ws.onerror = null;
        self.ws.onmessage = null;
        self.ws = null;
        self.connect()
    }
}

export default {
    WebSocketClient
}